// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1uFr6","label":"LabeledBox_label__3XAtW"};